import LangEnum from '../../../../../../../../lang/LangEnum';
import { useApplicationContext } from '../../../../../../../context/ApplicationContext/ApplicationContext';
import { useTranslation } from '../../../../../../../translation/TranslationContext';
import { useChatContext } from '../../../../../../contexts/chat/chat.context';
import ChatHeaderTemplate from '../../../../../ChatHeaderTemplate/ChatHeaderTemplate';
import { useChatMessagesContext } from '../../../../contexts/chatMessages.context';

const EditChatFormHeader = () => {
  const { translate } = useTranslation();

  const { goToChat } = useChatMessagesContext();
  const { closeActiveChat } = useChatContext();

  const { state } = useApplicationContext();

  if (!state.user) {
    return null;
  }

  return (
    <ChatHeaderTemplate.Template onClose={closeActiveChat} onClickGoBack={goToChat}>
      <ChatHeaderTemplate.Title text={translate(LangEnum.CHAT_HEADER_EDIT_GROUP)} />
    </ChatHeaderTemplate.Template>
  );
};

export default EditChatFormHeader;
